/* eslint-disable no-console */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { connectAuthEmulator } from "firebase/auth";

// Initialize Firebase
const firebaseConfig = {
  ...window.config
};

const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();

// Make sure to set up the emulator before making any auth or firestore calls
if (window.env === "emulator") {
  console.log("Using Firebase Auth and Firestore Emulators");

  // Set the auth emulator BEFORE any auth calls are made
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });

  // Set the Firestore emulator
  firebase.firestore().useEmulator("localhost", 8080);
}

// Now you can safely use the Firebase Auth instance

// Set up other authentication methods
const signInAnonymously = firebase;

const EmailAuthProvider = firebase.auth.EmailAuthProvider;
const signInWithEmailAndPassword = auth.signInWithEmailAndPassword;
const signOut = auth.signOut;

console.log("====> ", app.name); // '[DEFAULT]'

// Exposes config.firebase to be able to login with tokens and generate PDFs
window.firebase = firebase;

const initApp = () => {
  console.log("initialized app");
};

export {
  initApp,
  firebase,
  auth,
  signInAnonymously,
  app,
  EmailAuthProvider,
  signInWithEmailAndPassword,
  signOut
};
